import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ADMIN_API_SERVER_URL } from '../tokens/admin-api-server-url.token';
import { ServerBaseService } from '../server-base.service';
import { BehaviorSubject, Observable, combineLatest, map } from 'rxjs';
import { StatusWithFlags } from '@equipmyschool/emsadminweb-models';

@Injectable({
  providedIn: 'root'
})
export class StatusService extends ServerBaseService {
  private _id$ = new BehaviorSubject<number | null>(null);
  private id$ = this._id$.asObservable();
  private _statuses$ = new BehaviorSubject<StatusWithFlags[]>([]);
  public statuses$ = this._statuses$.asObservable();

  public status$: Observable<StatusWithFlags | undefined> = combineLatest([this.statuses$, this.id$]).pipe(map(([statuses, id]) => statuses.find(status => status.StatusID == id)));

  constructor(http: HttpClient, @Inject(ADMIN_API_SERVER_URL) serverUrl: string) {
    super(http, serverUrl)

    this.request<StatusWithFlags[]>('GET', 'Status/Get').subscribe({
      next: (statuses => this._statuses$.next(statuses))
    });
  }

  public getStatus(statusId: number) {
    this._id$.next(statusId);
  }
}
